export default class ClipboardHelper {
  static copyToClipboard(value: string) {
    navigator.clipboard.writeText(value);
  }
}
